module.exports = __webpack_public_path__ + "img/contact-noname.b2971c14.png";